import Vue from 'vue';
import { PRODUCT_ROUTES, FAMILIES_ROUTES } from '../constants/routes';
import config from '../config/config.json';
import NotificationService from '@/helpers/notification';

class ProductService {
  constructor() {}

  async get() {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}`
    );

    Vue.localStorage.set('listProduct', response.data);
  }

  async getProduct(searchCriteria) {
    const response = await Vue.prototype.$http
      .post(`${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}/${PRODUCT_ROUTES.SEARCH_PRODUCT}`,
      searchCriteria);

    return response.data;
  }

  async getProductFamilies() {
    const url = `${config.apiUrl}${FAMILIES_ROUTES.BASE_URL}/${FAMILIES_ROUTES.NAMES}/${FAMILIES_ROUTES.ALL}`;
    const response = await Vue.prototype.$http.get(url);

    Vue.localStorage.set('productFamilies', response.data);
  }

  async getProductsByFamily(family) {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}/${PRODUCT_ROUTES.FAMILY}`,
      {
        params: {
          familyName: family
        }
      }
    );

    Vue.localStorage.set('familyProducts', response.data);
  }

  async getProductsExportFile(familyName, isMana) {
    const url = `${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}/Export`;
     const response = await Vue.prototype.$http.get(url, {
       params: {
         familyName: familyName
       }
     });
 
     return response.data;
  }

  async createProduct(newProduct) {
    const response = await Vue.prototype.$http
      .post(`${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}`, newProduct)
      .catch(error => NotificationService.error(error));

    if (!!response) {
      NotificationService.success('The product has been created.');
    }

    return response;
  }

  async delete(id) {
    const response = await Vue.prototype.$http
      .delete(`${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}/${id}`)
      .catch(error => NotificationService.error(error));

    if (!!response) {
      NotificationService.success('Product has been deleted.');
    }
    return response;
  }

  async update(product) {
    const response = await Vue.prototype.$http
      .put(`${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}`, product)
      .catch(error => NotificationService.error(error));

    if (!!response) {
      NotificationService.success('The product has been updated.');
    }
    return response;
  }

  async updateStateProductToPublished(productsIds) {
    const response = await Vue.prototype.$http.put(
      `${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}/${PRODUCT_ROUTES.UPDATE_STATE_PRODUCT_TO_PUBLISH}`,
      productsIds
    );

    return response;
  }

  async updateStateProductToUnpublished(productsIds) {
    const response = await Vue.prototype.$http.put(
      `${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}/${PRODUCT_ROUTES.UPDATE_STATE_PRODUCT_TO_UNPUBLISH}`,
      productsIds
    );

    return response;
  }
}

export default new ProductService();
